import axios from "axios";
import { ADMIN_TOKEN_KEY } from "./authApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EVENT_SLUG = "davangere-members-day-2026";

function headers(extra = {}) {
  const t = localStorage.getItem(ADMIN_TOKEN_KEY);
  return { ...(t ? { Authorization: `Bearer ${t}` } : {}), ...extra };
}

export const reconciliationApi = {
  summary: () => axios.get(`${API}/admin/reconciliation/summary`, { params: { event_slug: EVENT_SLUG }, headers: headers() }).then((r) => r.data),
  list: (limit = 100) => axios.get(`${API}/admin/reconciliation/settlements`, { params: { event_slug: EVENT_SLUG, limit }, headers: headers() }).then((r) => r.data),
  unreconciled: () => axios.get(`${API}/admin/reconciliation/unreconciled-payments`, { params: { event_slug: EVENT_SLUG }, headers: headers() }).then((r) => r.data),
  create: (body) => axios.post(`${API}/admin/reconciliation/settlements`, { event_slug: EVENT_SLUG, ...body }, { headers: headers() }).then((r) => r.data),
};
